import React from 'react';

import __ from '@vitafy/common-libraries/frontend/Translate';
import ReviewComp from './Review';
import Review from '../../server/domain/Review';
import ReviewSummary from '../../server/domain/ReviewSummary';
import Pagination from './Pagination';
import { LoadReviewsActionPayload } from '../redux/actions';

export type ReviewCollection = {
  reviews: Review[];
  reviewSummary?: ReviewSummary;
};

export type ReviewListMeta = {
  reviews: Review[];
  isLoading?: boolean;
  isBundle?: boolean;
  locale: string;
  limit?: number;
  reviewsMap: Map<number, Review[]>;
  reviewSummary: ReviewSummary;
  page: number;
  totalPages: number;
  loadReviews?: (payload: LoadReviewsActionPayload) => void;
};

const ReviewsList: React.FC<ReviewListMeta> = ({
  reviews,
  reviewsMap,
  page,
  locale,
  limit,
  isLoading,
  isBundle
}) => (
  <div>
    <div>
      {isLoading == true
        ? Array.from({ length: limit }, (v, i) => i).map((index) => <LoadingSkeleton key={index} />)
        : reviews.length === 0
        ? ''
        : reviewsMap &&
          reviewsMap.size &&
          reviewsMap
            .get(Number(page))
            .map((review, index) => (
              <ReviewComp key={index} {...review} product={isBundle ? review.product : ''} locale={locale} />
            ))}
      {!reviewsMap &&
        reviews.map((review, index) => (
          <ReviewComp key={index} {...review} product={isBundle ? review.product : ''} locale={locale} />
        ))}
      <p className="text-small">
        {__({
          val: 'Verified reviews are written from registered users',
          locale
        })}
      </p>
      <Pagination />
    </div>
  </div>
);

const LoadingSkeleton: React.FC = () => (
  <article className="block">
    <div className="row">
      <div className="medium-3 large-2 columns">
        <header>
          <span className="skeleton-box" style={{ width: '4rem', marginRight: '100%' }} />
          <div className="rating-box rating-bottom-margin">
            <div className="rating" style={{ width: '0%' }} />
          </div>
        </header>
      </div>
      <div className="medium-9 large-10 columns">
        <span className="skeleton-box" style={{ width: '9rem' }} />
        <p className="mtn">
          <span className="skeleton-box" style={{ width: '70%' }} />
          <span className="skeleton-box" style={{ width: '90%' }} />
          <span className="skeleton-box" style={{ width: '85%' }} />
          {/* <span className="skeleton-box" style={{width: '50%'}} /> */}
        </p>
        <small className="text-subtle">
          <span className="skeleton-box" style={{ width: '40%', height: '0.75rem' }} />
        </small>
      </div>
    </div>
  </article>
);

export default ReviewsList;
